import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { GRADE_ITEMS, TrainingContent, TRAINING_NAME_SELECT_ITEMS } from 'entities/training_content'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'

export const trainingContentColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',

        values: [
            {
                align: 'center',
                name: '実施日',
                th: true,
                width: 25,
                form: form,
                orderAttr: 'training_content_date',
                searchType: { name: 'date', type: 'text' },
            },
            {
                align: 'center',
                name: '項目',
                th: true,
                width: 70,
                form: form,
                orderAttr: 'training_content_record_type',
                searchType: { name: 'RecordType', type: 'multiple_select', selectItems: TRAINING_NAME_SELECT_ITEMS },
            },
            {
                align: 'center',
                name: '内容',
                th: true,
                width: 150,
                form: form,
                orderAttr: 'training_content_content',
                searchType: { name: 'content', type: 'multiple_text' },
            },
            {
                align: 'center',
                name: '評価',
                th: true,
                width: 70,
                form: form,
                orderAttr: 'training_content_grade',
                searchType: { name: 'grade', type: 'multiple_select', selectItems: GRADE_ITEMS },
            },
            {
                align: 'center',
                name: 'ユーザー名',
                th: true,
                width: 150,
                form: form,
                orderAttr: 'user_first_name',
                searchType: { name: 'user_first_name', type: 'text' },
            },
            {
                align: 'center',
                name: '備考',
                th: true,
                width: 150,
            },
        ],
    }
}

export type TrainingContentTableDataProps = {
    trainingContent?: TrainingContent
    displaySetting: DisplaySetting
}

export const TrainingContentTableData = ({ trainingContent, displaySetting }: TrainingContentTableDataProps): JSX.Element => {
    if (!trainingContent) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">{toDateText(trainingContent.date)}</TableCell>
                <TableCell align="center">{trainingContent.recordType === 'accessment' ? '技能評価' : '教育'}</TableCell>
                <TableCell align="center">{trainingContent.content}</TableCell>
                <TableCell align="center">{trainingContent.grade}</TableCell>
                <TableCell align="center">{trainingContent.trainingLedgerMaster?.user?.fullName}</TableCell>
                <TableCell align="center">{trainingContent.memo}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
